var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGasStationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 6,
    fill: "#FF3D17"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1396_4988)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.885 7.615L13.89 7.61L12.295 6.015C12.15 5.87 11.91 5.87 11.765 6.015C11.62 6.16 11.62 6.4 11.765 6.545L12.555 7.335C12.03 7.535 11.675 8.07 11.765 8.69C11.845 9.24 12.315 9.685 12.865 9.745C13.1 9.77 13.305 9.73 13.5 9.645V13.25C13.5 13.525 13.275 13.75 13 13.75C12.725 13.75 12.5 13.525 12.5 13.25V11C12.5 10.45 12.05 10 11.5 10H11V6.5C11 5.95 10.55 5.5 10 5.5H7C6.45 5.5 6 5.95 6 6.5V14C6 14.275 6.225 14.5 6.5 14.5H10.5C10.775 14.5 11 14.275 11 14V10.75H11.75V13.18C11.75 13.835 12.22 14.43 12.87 14.495C13.62 14.57 14.25 13.985 14.25 13.25V8.5C14.25 8.155 14.11 7.84 13.885 7.615ZM10 9H7V7C7 6.725 7.225 6.5 7.5 6.5H9.5C9.775 6.5 10 6.725 10 7V9ZM13 9C12.725 9 12.5 8.775 12.5 8.5C12.5 8.225 12.725 8 13 8C13.275 8 13.5 8.225 13.5 8.5C13.5 8.775 13.275 9 13 9Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1396_4988"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasStationIcon);
export default __webpack_public_path__ + "static/media/gas_station_icon.ab47a45e8734db8627b3606ef86a9266.svg";
export { ForwardRef as ReactComponent };